export const directIntegrationsPath = (type, slug) =>
  `/partner-portal/${type}/${slug}/direct-integration`

export const platformsPath = (type, slug) =>
  `/partner-portal/${type}/${slug}/platforms`
